import { inject, Injectable, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import { ContactRequestSendCommand, ContactRequestSendCommandResult } from '../../INTEGRA_Shop_Client';
import { IContactRequestApiService, IContactRequestApiServiceToken } from '../../api/contact-request/contact-request-api-service.interface';
import { IContactRequestService, IContactRequestServiceToken } from './contact-request-service.interface';

@Injectable({
  providedIn: 'root'
})
export class ContactRequestService implements IContactRequestService {
  private readonly contactRequestApiService: IContactRequestApiService;

  public constructor() {
    this.contactRequestApiService = inject(IContactRequestApiServiceToken);
  }

  public contactRequestSend(contactRequestSendCommand: ContactRequestSendCommand): Observable<ContactRequestSendCommandResult> {
    return this.contactRequestApiService.contactRequestSend(contactRequestSendCommand);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContactRequestServiceProvider: Provider[] = [
  { provide: IContactRequestServiceToken, useExisting: ContactRequestService }
];
